import {get_nested_plain} from "./misc";

export const trans = (plain_key, translations, default_value = null) => {
  return get_nested_plain(
    plain_key,
    translations,
    default_value ?? plain_key
  )
}
